export enum BadgeColor {
  SecondaryPigmentIndigo = 'secondaryPigmentIndigo',
  SecondaryCerulean = 'secondaryCerulean',
  TetrieryCerulean = 'tetrieryCerulean',
  SecondaryYellow = 'secondaryYellow',
  TertiaryOrange = 'tertiaryOrange',
  AdditionalGrey = 'additionalGrey',
  SecondaryGreen = 'secondaryGreen',
  TertiaryGreen = 'tertiaryGreen',
  AdditionalRed = 'additionalRed',
  TetrieryBlue = 'tetrieryBlue',
  SecondaryRed = 'secondaryRed',
  Transparent = 'transparent',
  LightGrey = 'lightGrey',
  RedAlert = 'redAlert',
  Between = 'between',
  Yellow = 'yellow',
  Green = 'green',
  Grey = 'grey',
  Blue = 'blue',
  Pink = 'pink',
  Red = 'red',
  Tag = 'tag',
  New = 'new',
}

export enum Feature {
  USERS = 'users',
  ROLES = 'roles',
  SALES = 'sales',
  EVENTS = 'events',
  FISERV = 'fiserv',
  THEMES = 'themes',
  CLOVER = 'clover',
  REPORTS = 'reports',
  PAYOUTS = 'payouts',
  CHECKOUT = 'checkout',
  CARRIERS = 'carriers',
  PRODUCTS = 'products',
  ANALYTICS = 'analytics',
  COMPANIES = 'companies',
  DASHBOARD = 'dashboard',
  INVENTORY = 'inventory',
  SHIPMENTS = 'shipments',
  EMPLOYEES = 'employees',
  CUSTOMERS = 'customers',
  ACCOUNTING = 'accounting',
  USER_PROFILE = 'user_profile',
  EVENT_ORDERS = 'event_orders',
  EVENT_MANAGER = 'event_manager',
  PRODUCT_TYPES = 'product_types',
  EVENT_REVIEWS = 'event_reviews',
  NOTIFICATIONS = 'notifications',
  REIMBURSEMENTS = 'reimbursements',
  PRICE_APPROVAL = 'price_approval',
  EVENT_EXPENSES = 'event_expenses',
  PAYMENT_METHODS = 'payment_methods',
  EMPLOYEE_CREATE = 'employee_create',
  EVENTS_CALENDAR = 'events_calendar',
  RECEIPT_SETTINGS = 'receipt_settings',
  CUSTOMER_SUPPORT = 'customer_support',
  EVENT_COMPETITION = 'event_competition',
  EMPLOYEE_COMPETITION = 'employee_competition',
}

export enum PayoutType {
  Tip = 'Tip',
  Fee = 'Fee',
  Misc = 'Misc',
  Bonus = 'Bonus',
  Refund = 'Refund',
  Expense = 'Expense',
  Advance = 'Advance',
  Dispute = 'Dispute',
  Penalty = 'Penalty',
  Earnings = 'Earnings',
  Adjustment = 'Adjustment',
  NegativeTip = 'Negative Tip',
  FreeShipping = 'Free Shipping',
  PrepaidBonus = 'Prepaid Bonus',
  Reimbursements = 'Reimbursements',
  PrepaidAdvance = 'Prepaid Advance',
  PrepaidExpense = 'Prepaid Expense',
  NegativeEarnings = 'Negative Earnings',
  NegativeAdjustment = 'Negative Adjustment',
  PrepaidReimbursements = 'Prepaid Reimbursements',
}

export enum ButtonColors {
  LightCerulean = 'lightCerulean',
  PigmentIndigo = 'pigmentIndigo',
  TetrieryGrey = 'tetrieryGrey',
  LightYellow = 'lightYellow',
  LightPurple = 'lightPurple',
  Transparent = 'transparent',
  BlackWhite = 'blackWhite',
  WhiteBlack = 'whiteBlack',
  LightGreen = 'lightGreen',
  LightBlue = 'lightBlue',
  LightGrey = 'lightGrey',
  WhiteBlue = 'whiteBlue',
  LightRed = 'lightRed',
  Yellow = 'yellow',
  Green = 'green',
  Blue = 'blue',
  Red = 'red',
}

export enum ChargebackReason {
  Defective = 'defective',
  Duplicate = 'duplicate',
  IncorrectAmount = 'incorrectAmount',
  CancelledService = 'cancelledService',
  GoodsCancelled = 'goodsCancelled',
  GoodsReturned = 'goodsReturned',
  AbsentEnvironment = 'absentEnvironment',
}

export enum BackOfficeRoles {
  RESEARCH_MANAGER = 'Research Manager',
  RESEARCH_REP = 'Research Rep',
  ACCOUNTING = 'Accounting',
  CUSTOMER_SERVICE_REP = 'Customer Service Rep',
  ADMIN_REP = 'Admin Rep',
  SALES_REP = 'Sales Rep',
  MANAGER = 'Manager',
  ADMINISTRATIVE = 'Administrative',
}

export enum ErrorColor {
  LightGreen = 'lightGreen',
  LightBlue = 'lightBlue',
  LightRed = 'lightRed',
  Yellow = 'yellow',
  Orange = 'orange',
  Black = 'black',
  Green = 'green',
  Grey = 'grey',
  Blue = 'blue',
  Red = 'red',
}

export enum TextColor {
  Secondary = 'secondary',
  Primary = 'primary',
  Inverse = 'inverse',
  Mention = 'mention',
  Green = 'green',
  White = 'white',
  Black = 'black',
  Blue = 'blue',
  Red = 'red',
}

export enum PayoutStatus {
  Paid = 'paid',
  Lost = 'lost',
  Pending = 'pending',
  Approved = 'approved',
  NotApproved = 'notApproved',
  LostTemporary = 'lostTemporary',
  PartialApproved = 'partialApproved',
}

export enum TeamMemberColor {
  Cerulean = '#0BA5D3',
  Purple = '#C15CAB',
  Orange = '#C8791B',
  Yellow = '#DAA403',
  Green = '#01B55B',
  Blue = '#2576FA',
  Red = '#FE4B4B',
}

export enum ListCardStyle {
  LightRed = 'lightRed',
  LightPuprle = 'lightPuprle',
  LightCerulean = 'lightCerulean',
  Default = 'default',
  Green = 'green',
  Grey = 'grey',
}

export enum EventOrderStatus {
  PAID = 'paid',
  UNPAID = 'unpaid',
  SHIPPED = 'shipped',
  ON_HOLD = 'on_hold',
  CANCELLED = 'cancelled',
}

export enum CardType {
  Visa = 'visa',
  UnionPay = 'unionPay',
  Discover = 'discover',
  Mastercard = 'mastercard',
  AmericanExpress = 'americanExpress',
}

export enum DepositType {
  Deposit = 'deposit',
  Withdrawals = 'withdrawals',
  ResolvedTransactions = 'resolvedTransactions',
  HeldFunds = 'heldFunds',
}

export enum ChargebackStatus {
  Review = 'underReview',
  ClosedWon = 'closedWon',
  ClosedLost = 'closedLost',
  ActionRequired = 'actionRequired',
}

export enum AvatarColor {
  Cerulean = 'cerulean',
  Yellow = 'yellow',
  Orange = 'orange',
  Green = 'green',
  Blue = 'blue',
  Pink = 'pink',
}

export enum TotalCardType {
  GrossTotal = 'grossTotal',
  NetTotal = 'netTotal',
  MonthlySales = 'monthlySales',
  YearlySales = 'yearlySales',
  TaxTotal = 'taxTotal',
  ProcessingFeeTotal = 'processingFeeTotal',
  TipTotal = 'tipTotal',
  ShippingTotal = 'shippingTotal',
}

export enum BadgePadding {
  WideMedium = '2px 8px',
  Default = '4px 8px',
  Medium = '2px 4px',
  Big = '8px 16px',
  Small = '0 4px',
}

export enum EventLocationType {
  Corner = 'corner',
  Endcap = 'endcap',
  Inline = 'inline',
  Island = 'island',
  Sqf = 'sqf',
}

export enum CheckboxColor {
  SecondaryBlue = 'secondaryBlue',
  Green = 'green',
  Blue = 'blue',
  Red = 'red',
}

export enum Roles {
  SITE_ADMIN = 'Site Admin',
  COMPANY_OWNER = 'Company Owner',
  BACKOFFICE = 'Backoffice',
}

export enum CashCardType {
  Cash = 'cash',
  Out = 'out',
  Balance = 'balance',
  Expenses = 'expenses',
}

export enum PriceApprovalStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum PaymentMethodType {
  Gift = 'gift',
  Cash = 'cash',
  Check = 'check',
  Credit = 'credit',
}

export enum ButtonStyleTypes {
  Standard = 'standard',
  Outline = 'outline',
  Ghost = 'ghost',
}

export enum EmployeePaymentWireType {
  Domestic = 'domestic',
  International = 'international',
}

export enum BadgeCursor {
  Inherit = 'inherit',
  Default = 'default',
  Pointer = 'pointer',
}

export enum MonthlyTaxStatus {
  Due = 'due',
  Paid = 'paid',
  PartialPaid = 'partialPaid',
}

export enum EmployeeRecipientType {
  Business = 'business',
  Individual = 'individual',
}

export enum EmployeePaymentAccountType {
  Saving = 'saving',
  Checking = 'checking',
}

export enum BadgeBorderRadius {
  Default = '8px',
  Small = '4px',
  Big = '16px',
}

export enum EventInventory {
  End = 'End',
  Sold = 'Sold',
  Start = 'Start',
}

export enum SalesCompatitionPosition {
  Second = 2,
  First = 1,
  Third = 3,
}

export enum FileType {
  Image = 'image',
  Video = 'video',
  File = 'file',
}

export enum TitleLevel {
  P = 'p',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
}

export enum ErrorPadding {
  Default = '12px 16px',
  Small = '8px 16px',
}

export enum ExpensesInfo {
  Amount = 'Amount',
  Expenses = 'Expenses',
}

export enum EmployeePaymentMethodType {
  ACH = 'ach',
  Wire = 'wire',
}

export enum CustomerStatus {
  New = 'new',
  Existing = 'existing',
}

export enum EventType {
  Indoor = 'indoor',
  Outdoor = 'outdoor',
}

export enum DotsColor {
  Primary = 'primary',
  Grey = 'grey',
}

export enum TabCountColor {
  Blue = 'blue',
  Red = 'red',
}

export enum TrasnactionType {
  Chargeback = 'chargeback',
}

export enum CommissionType {
  Percent = 'percent',
}

export type Role = Roles | BackOfficeRoles;

export enum RefundPaymentMethod {
  Cash = 'cash',
  Credit = 'credit',
}

export enum RefundStatus {
  Full = 'full',
  Partial = 'partial',
}

export enum ExpensesType {
  Misc = 'misc',
  Bonus = 'bonus',
  Advance = 'advance',
  Expense = 'expense',
  Reimbursement = 'reimbursement',
}

export enum CheckoutType {
  Exchange = 'exchange',
  Purchase = 'purchase',
}

export enum EventOrderType {
  Exchange = 'exchange',
  Purchase = 'purchase',
}

export enum NotificationType {
  DayOpen = 'dayOpen',
  Losses = 'newLosses',
  NewEvent = 'newEvent',
  DayClose = 'dayClose',
  NewRefund = 'newRefund',
  OfferEvent = 'offerEvent',
  NewExpense = 'newExpense',
  NewProduct = 'newProduct',
  NewStorage = 'newStorage',
  AcceptEvent = 'acceptEvent',
  NewSupplier = 'newSupplier',
  NewCustomer = 'newCustomer',
  NewEmployee = 'newEmployee',
  NewExchange = 'newExchange',
  NewRetrieval = 'newRetrieval',
  NewSaleAbove = 'newSaleAbove',
  NewSaleBelow = 'newSaleBelow',
  NewChargeback = 'newChargeback',
  NewStockOrder = 'newStockOrder',
  NewEventOrder = 'newEventOrder',
  RefundApproval = 'refundApproval',
  NewEventReview = 'newEventReview',
  UpdateRetrieval = 'updateRetrieval',
  NewTransferSend = 'newTransferSend',
  UpdateChargeback = 'updateChargeback',
  NewExchangeOrder = 'newExchangeOrder',
  DailySalesSummary = 'dailySalesSummary',
  SaleUnderApproval = 'saleUnderApproval',
  MonthlySalesSummary = 'monthlySalesSummary',
  UpdateStockOrderStatus = 'updateStockOrderStatus',
  UpdateEventOrderStatus = 'updateEventOrderStatus',
  UpdateExchangeOrderStatus = 'updateExchangeOrderStatus',
}

export enum NotificationChannel {
  App = 'app',
  Sms = 'sms',
  Email = 'email',
}

export enum EventSummaryReportTab {
  Dashboard = 'dashboard',
  Revenue = 'revenue',
  Expenses = 'expenses',
  CashFlow = 'cashFlow',
  // TODO: uncomment when it was ready
  // Received = 'received',
  Inventory = 'inventory',
  Bonuses = 'bonuses',
  Reimbursements = 'reimbursements',
  Commissions = 'commissions',
  ProfitAndLosses = 'profitAndLosses',
  StockOrders = 'stockOrders',
  Refunds = 'refunds',
}

export enum CloverVoidReason {
  UserCancel = 'USER_CANCEL',
  TransportError = 'TRANSPORT_ERROR',
  RejectSignature = 'REJECT_SIGNATURE',
  RejectPartialAuth = 'REJECT_PARTIAL_AUTH',
  NotApproved = 'NOT_APPROVED',
  Failed = 'FAILED',
  AuthClosedNewCard = 'AUTH_CLOSED_NEW_CARD',
  DeveloperPayPartialAuth = 'DEVELOPER_PAY_PARTIAL_AUTH',
  RejectDuplicate = 'REJECT_DUPLICATE',
  RejectOffline = 'REJECT_OFFLINE',
  GiftcardLoadFailed = 'GIFTCARD_LOAD_FAILED',
  UserGiftcardLoadCancel = 'USER_GIFTCARD_LOAD_CANCEL',
  DeveloperPayTipAdjustFailed = 'DEVELOPER_PAY_TIP_ADJUST_FAILED',
  UserCustomerCancel = 'USER_CUSTOMER_CANCEL',
  Fraud = 'FRAUD',
}

export enum SendMailType {
  Refund = 'refund',
  Checkout = 'checkout',
}

export enum Carrier {
  UPS = 'ups_walleted',
  USPS = 'stamps_com',
  FedEx = 'fedex',
}

export enum ShipStationNotification {
  SMS = 'sms',
  Email = 'email',
}

export enum PaymentIntentStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Timeout = 'TIMEOUT',
}

export enum SendReceiptType {
  Default = 'default',
  Gift = 'gift',
}

export enum CloverReceiptType {
  Void = 'void',
  Refund = 'refund',
  Payment = 'payment',
}

export enum PayoutAdjustmentReason {
  Void = 'void',
  Other = 'other',
  Refund = 'refund',
  Chargeback = 'chargeback',
  Correction = 'correction',
}

export enum FiservRetrievalStatus {
  Open = 'open',
  Closed = 'closed',
  Responded = 'responded',
  Escalated = 'escalated',
  InProgress = 'inProgress',
}

export enum FiservDisposition {
  OpenCase = 'Open Case',
  CloseCase = 'Close Case',
  ResolveToGL = 'Resolve to GL',
  MerchantAccept = 'Merchant Accept',
  ResolveToMerchant = 'Resolve to Merchant',
  ResolveToGLReversal = 'Resolve to GL (Reversal)',
  AcceptPendForReview = 'Accept - Pend for Review',
  MerchantRebuttalReject = 'Merchant Rebuttal Reject',
  ReceiveMerchantResponse = 'Receive Merchant Response',
  MerchantRebuttalReceived = 'Merchant Rebuttal Received',
  SendLetterToMerchant = 'Send Letter to Merchant (Incom Exc)',
  NoMerchantResponseReceived = 'No Merchant Response Received',
  NoAssociationResponseReceived = 'No Association Response Received',
  RejectToIssuerPendForReview = 'Reject to Issuer - Pend for Review',
  ResolveToIssuerPendForReview = 'Resolve to Issuer - Pend for Review',
}
